import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    filter : {},
    queueFilter : {},
    savedFilters : []
  },
  reducers: {
    addFilter(state, action){

        if (!action || !action.payload ) return;

        state.filter.filterName = action.payload.filterName;

        if(action.payload.groups){
          if(!state.filter.groups) {
            state.filter.groups = [];
          }

          action.payload.groups.forEach(group => {
            if(!state.filter.groups.some(filterGroup => filterGroup.id === group.id)){
              state.filter.groups.push(group);
            }
          })
        }

        if(action.payload.skillGroups){
          if(!state.filter.skillGroups) {
            state.filter.skillGroups = [];
          }

          action.payload.skillGroups.forEach(group => {
            if(!state.filter.skillGroups.some(filterGroup => filterGroup.id === group.id)){
              state.filter.skillGroups.push(group);
            }
          })
        }

        if(action.payload.skills){
          if(!state.filter.skills) {
            state.filter.skills = [];
          }

          action.payload.skills.forEach(skill => {
            if(!state.filter.skills.some(filterSkill => filterSkill.id === skill.id)){
              state.filter.skills.push(skill);
            }
          })
        }

        if(action.payload.languages){
          if(!state.filter.languages) {
            state.filter.languages = [];
          }

          action.payload.languages.forEach(language => {
            if(!state.filter.languages.some(filterLanguage => filterLanguage.id === language.id)){
              state.filter.languages.push(language);
            }
          })
        }

        if(action.payload.queues){
          if(!state.filter.queues) {
            state.filter.queues = [];
          }

          action.payload.queues.forEach(queue => {
            if(!state.filter.queues.some(filterQueue => filterQueue.id === queue.id)){
              state.filter.queues.push(queue);
            }
          })
        }

        if(action.payload.queueActivations){
          if(!state.filter.queueActivations) {
            state.filter.queueActivations = [];
          }

          action.payload.queueActivations.forEach(queue => {
            if(!state.filter.queueActivations.some(filterQueue => filterQueue.id === queue.id)){
              state.filter.queueActivations.push(queue);
            }
          })
        }

        if(action.payload.teams){
          if(!state.filter.teams) {
            state.filter.teams = [];
          }

          action.payload.teams.forEach(team => {
            if(!state.filter.teams.some(filterTeam => filterTeam.id === team.id)){
              state.filter.teams.push(team);
            }
          })
        }

        if(action.payload.divisions){
          if(!state.filter.divisions) {
            state.filter.divisions = [];
          }

          action.payload.divisions.forEach(division => {
            if(!state.filter.divisions.some(filterDivision => filterDivision.id === division.id)){
              state.filter.divisions.push(division);
            }
          })
        }

        if(action.payload.users){
          if(!state.filter.users) {
            state.filter.users = [];
          }

          action.payload.users.forEach(user => {
            if(!state.filter.users.some(filterUser => filterUser.id === user.id)){
              state.filter.users.push(user);
            }
          })
        }

        if(action.payload.departments){
          if(!state.filter.departments) {
            state.filter.departments = [];
          }

          action.payload.departments.forEach(department => {
            if(!state.filter.departments.some(filterDepartment => department === filterDepartment)){
              state.filter.departments.push(department);
            }
          })
        }

        if(action.payload.userStatus){
          state.filter.userStatus = action.payload.userStatus;
        }
    },
    removeFilter(state, action) {
      if (!action || !action.payload ) return; 

      //Changing filters -> no longer == saved filter -> remove filter name
      if('filterName' in state.filter) {
        delete state.filter["filterName"];
      }

      if (!state.filter.groups 
          && !state.filter.skillGroups
          && !state.filter.skills 
          && !state.filter.languages 
          && !state.filter.queues
          && !state.filter.queueActivations
          && !state.filter.teams
          && !state.filter.users
          && !state.filter.departments
          && !state.filter.divisions
          && !state.filter.userStatus
        ) return;       //No groups, queues or skills in filter -> return

      if(action.payload.groups && state.filter.groups){
        action.payload.groups.forEach(group => {
          state.filter.groups = state.filter.groups
                                    .filter((existingGroup) => group.id !== existingGroup.id);

        })

        if(state.filter.groups && state.filter.groups.length === 0 ){
          delete state.filter["groups"];
        }
      }

      if(action.payload.skillGroups && state.filter.skillGroups){
        action.payload.skillGroups.forEach(group => {
          state.filter.skillGroups = state.filter.skillGroups
                                    .filter((existingGroup) => group.id !== existingGroup.id);

        })

        if(state.filter.skillGroups && state.filter.skillGroups.length === 0 ){
          delete state.filter["skillGroups"];
        }
      }

      if(action.payload.skills && state.filter.skills){
        action.payload.skills.forEach(skill => {
          state.filter.skills = state.filter.skills
                                    .filter((existingSkill) => skill.id !== existingSkill.id);
        })

        if(state.filter.skills && state.filter.skills.length === 0 ){
          delete state.filter["skills"];
        }
      }

      if(action.payload.languages && state.filter.languages){
        action.payload.languages.forEach(language => {
          state.filter.languages = state.filter.languages
                                    .filter((existingLanguage) => language.id !== existingLanguage.id);
        })

        if(state.filter.languages && state.filter.languages.length === 0 ){
          delete state.filter["languages"];
        }
      }
      
      if(action.payload.queues && state.filter.queues){
        action.payload.queues.forEach(queue => {
          state.filter.queues = state.filter.queues
                                    .filter((existingQueue) => queue.id !== existingQueue.id);
        })

        if(state.filter.queues && state.filter.queues.length === 0 ){
          delete state.filter["queues"];
        }
      }

      if(action.payload.queueActivations && state.filter.queueActivations){
        action.payload.queueActivations.forEach(queue => {
          state.filter.queueActivations = state.filter.queueActivations
                                    .filter((existingQueue) => queue.id !== existingQueue.id);
        })

        if(state.filter.queueActivations && state.filter.queueActivations.length === 0 ){
          delete state.filter["queueActivations"];
        }
      }

      if(action.payload.teams && state.filter.teams){
        action.payload.teams.forEach(team => {
          state.filter.teams = state.filter.teams
                                    .filter((existingTeam) => team.id !== existingTeam.id);
        })

        if(state.filter.teams && state.filter.teams.length === 0 ){
          delete state.filter["teams"];
        }
      }

      if(action.payload.divisions && state.filter.divisions){
        action.payload.divisions.forEach(division => {
          state.filter.divisions = state.filter.divisions
                                    .filter((existingDivision) => division.id !== existingDivision.id);
        })

        if(state.filter.divisions && state.filter.divisions.length === 0 ){
          delete state.filter["divisions"];
        }
      }

      if(action.payload.users && state.filter.users){
        action.payload.users.forEach(user => {
          state.filter.users = state.filter.users
                                    .filter((existingUser) => user.id !== existingUser.id);
        })

        if(state.filter.users && state.filter.users.length === 0 ){
          delete state.filter["users"];
        }
      }

      if(action.payload.departments && state.filter.departments){
        action.payload.departments.forEach(department => {
          state.filter.departments = state.filter.departments
                                    .filter((existingDepartment) => !department.id ? department !== existingDepartment : department.id !== existingDepartment);
        })

        if(state.filter.departments && state.filter.departments.length === 0 ){
          delete state.filter["departments"];
        }
      }

      if(action.payload.userStatus && state.filter.userStatus){
        delete state.filter["userStatus"];
      }
    },
    setFilter(state, action){
      if(action && action.payload){
        state.filter = action.payload;
      }
    },
    setQueueFilter(state, action){
      if (!action || !action.payload ) return;

      if(action.payload.multipleQueues){
        state.queueFilter.multipleQueues = action.payload.multipleQueues;
      }

      if(state.queueFilter.multipleQueues && state.queueFilter.multipleQueues.length === 0 ){
        delete state.queueFilter["multipleQueues"];
      }
    },
    removeQueueFilter(state, action){
      if (!action || !action.payload ) return; 

      if(!state.queueFilter.multipleQueues
      ) return;       //No queues in filter -> return

      if(action.payload.multipleQueues && state.queueFilter.multipleQueues){
        action.payload.multipleQueues.forEach(queue => {
          state.queueFilter.multipleQueues = state.queueFilter.multipleQueues
                                    .filter((existingQueue) => queue.id !== existingQueue.id);
        })

        if(state.queueFilter.multipleQueues && state.queueFilter.multipleQueues.length === 0 ){
          delete state.queueFilter["multipleQueues"];
        }
      }

    },
    setSavedFilters(state, action){

      if(action && action.payload && action.payload.savedFilters){
        state.savedFilters = action.payload.savedFilters.sort((a, b) => a.filterName.toLowerCase().localeCompare(b.filterName.toLowerCase()));
      }
    },
    addSavedFilters(state, action){

    },
    clearFilters(state, action) {
      if (!action ) return; 
      state.filter = {};
    },
    clearQueueFilters(state, action) {
      console.log("Clearing Queue Filters");

      if (!action ) return; 
      state.queueFilter = {};
    },
    invalidateData(state, action) {
      state.dataValid = false;
    },
  },
});

export const filterActions = filterSlice.actions;

export default filterSlice;